import React from "react";
import { Outlet, Navigate,useLocation } from "react-router-dom";

export default function PrivateRouteBusiness() {
    let userid = localStorage.getItem("token") == null ? false : true;
    let business_id = localStorage.getItem("business_id") == null ? false : true;
    const expiry = localStorage.getItem("token_expiry");

     const is_profile_verify = localStorage.getItem("is_profile_verify_buss");

    //let role = parseInt(localStorage.getItem("role"));
     const location = useLocation();
    var chk=1;
    if(userid===false)
    {
        return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
    }else{
        if(business_id===false)
        {
            return <>{business_id ? <Outlet /> : <Navigate to="/" />}</>;
        }else{
            const now = new Date().getTime();
            if (now > parseInt(expiry)) {
                  localStorage.removeItem("token");
                  localStorage.removeItem("role");
                  localStorage.removeItem("business_id");
                  localStorage.removeItem("token_expiry");
                return <Navigate to="/business/login" />;
            }else{
                if(parseInt(is_profile_verify)===1)
                {
                    const expiryHours = 1;
                    const now = new Date();
                    const expiryTime = now.getTime() + expiryHours * 60 * 60 * 1000;
                    localStorage.setItem("token_expiry", expiryTime.toString());
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    const pagename=location.pathname;
                    if(pagename==='/business/complete-profile' || pagename==='/business/switch-neighbour-profile')
                    {
                        const expiryHours = 1;
                        const now = new Date();
                        const expiryTime = now.getTime() + expiryHours * 60 * 60 * 1000;
                        localStorage.setItem("token_expiry", expiryTime.toString());
                        return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                    }else{
                        return <>{chk === 1 ? <Navigate to="/business/complete-profile" /> : <Navigate to="/business/complete-profile" />}</>;
                    }
                }
            }
        }
    }
}